import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { Panel, Grid, Row, Col, Button, Message } from 'rsuite'
import { isEmpty } from 'lodash-es'
import { startLoading, doneLoading } from '../../utils/loading'
import { sendAssignExpertSended } from '../../redux/actions/assignExpert'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import pathname from '../../constants/pathname'
import './styles.less'
import ExpertName from '../../components/view/ExpertName'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import COIValidateWidget from '../coi/COIValidateWidget'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'

export default function SendSelectedExpert({
  schema,
  selectedExpert,
  onUpdateSchema,
  schemaButton,
  onSuccess = () => {},
  reviewerApproveList
}) {
  const SELECTED_EXPERT = 'selectedExpert'
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState()
  const [formSchema, setFormSchema] = useState(schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isCheckCOI, setIsCheckCOI] = useState(false)
  const [isCOIPass, setIsCOIPass] = useState(false)
  const [checkCOI, setCheckCOI] = useState(false)
  const [reviewerCount, setReviewerCount] = useState(0)
  const style = { marginBottom: 10 }

  useEffect(() => {
    // เก็บ id ที่ isSelected = true
    const selectedIds = selectedExpert
      ?.filter(i => i.isSelected && !i.sendConsiderDate)
      .map(i => i.id) || []
  
    // count จาก selectedExpert
    let count = selectedIds.length
  
    if (reviewerApproveList?.length) {
      const reviewerCount = reviewerApproveList.filter(i => {
        const isReviewerPassed = i.isApproved || !i.approvedReviewerDate
        // เช็ค id ซ้ำ ถ้ามีใน selectedIds แล้ว ไม่นับ
        return isReviewerPassed && !selectedIds.includes(i.id)
      }).length
  
      count += reviewerCount
    }
    console.log('count', count)
  
    setReviewerCount(count)
  }, [selectedExpert, reviewerApproveList])

  const handleOnSendAssignExpert = async (request) => {
    startLoading()
    setIsLoading(true)
    setErrorMessage(null)
    try {
      const _schema = await sendAssignExpertSended(request)
      doneLoading()
      await dispatch(getSchemaSidebar(projectId))
      sessionStorage.removeItem(SELECTED_EXPERT)
      onUpdateSchema()
      return
      // return history.push(`${pathname.proposal.review.reviewSummary}/${projectId}`)
    } catch (e) {
      setErrorMessage('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleRequest = () => {
    const itemList = selectedExpert.filter(i=> !i.sendConsiderDate).map((item) => {
      return {
        id: item.id,
        isOnline: item.isOnline,
        isSelected: item.isSelected,
        reviewType: item.reviewType
      }
    })
    const body = {
      projectVersionId: projectId,
      itemsList: itemList,
    }

    handleOnSendAssignExpert(body)
  }

  const handleSubmit = () => {
    if (
      isEmpty(selectedExpert) ||
      selectedExpert.length < formSchema.conditionOfReviewer?.countOfReviewer
    ) {
      setErrorMessage(`ต้องการผู้ทรงคุณวุฒิ${formSchema.conditionOfReviewer?.conditionDesc}`)
      return
    }

    setIsShowConfirm(true)
  }

  const onConfirm = () => {
    setIsShowConfirm(false)
    handleRequest()
  }

  const onCancle = () => {
    setIsShowConfirm(false)
  }

  return (
    <>
      <Panel className="send-selected-expert" shaded header="" bordered collapsible defaultExpanded>
        <Grid fluid>
          <Row>
            <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
              <h6 className="header">{formSchema.budgetInfo?.header}</h6>
            </Col>
            <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
              <span>{`${formSchema.budgetInfo?.budget.toLocaleString()} บาท`}</span>
            </Col>

            {reviewerApproveList.length == 0 && 
            <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
              <Message
                showIcon
                type="warning"
                description={`ต้องการผู้ทรงคุณวุฒิ${formSchema.conditionOfReviewer?.conditionDesc}`}
              />
            </Col>}
            {/* <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
              <span>{`ต้องการผู้ทรงคุณวุฒิ${formSchema.conditionOfReviewer?.conditionDesc}`}</span>
            </Col> */}
          </Row>
          <Row>
            {!isEmpty(selectedExpert) && selectedExpert?.some(i => i.isSelected) &&
              <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
                <h6 className="header">{formSchema.header}</h6>
              </Col>
            }
            {!isEmpty(selectedExpert) &&
              selectedExpert
                .filter((item) => item.isSelected)
                .map((item, index) => (
                  <ExpertName
                    key={item.id}
                    name={`${index + 1}) ${item.name}`}
                    email={item.email}
                    group={item.group}
                    emailMarginLeft={20}
                    reviewType={item.reviewType}
                    showReviewType
                  />
                  // <Col key={item.id} style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
                  //   {`${index + 1}) ${item.name}`}
                  // </Col>
                ))}
            <br />

            {!isEmpty(selectedExpert) && selectedExpert?.some(i => i.isSelected) &&
              <COIValidateWidget
                isCOIPass={isCOIPass}
                setIsCOIPass={setIsCOIPass}
                // checkCOI={checkCOI}
                // setCheckCOI={setCheckCOI}
                // setIsCheckCOI={setIsCheckCOI}
                hideCheckCOI={true}
                fixType={'5'}
              />
            }

            <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
              {!!errorMessage && (
                <Row style={{ marginBottom: 10 }}>
                  <Message showIcon type="error" description={errorMessage} />
                </Row>
              )}
            </Col>
            <Col style={{ marginBottom: 20, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
              {!isEmpty(selectedExpert) &&
              reviewerCount >= formSchema.conditionOfReviewer?.countOfReviewer ? (
                <>
                  <ApproverList
                    approveType={1}
                    projectversionId={projectId}
                    disabled={isLoading || !isCOIPass}
                    style={{ marginBottom: 10 }}
                    buttontext="ตรวจสอบสายอนุมัติและส่งพิจารณา"
                    isLoading={isLoading}
                    fetchButton={(disabled) =>
                      <SaveButton icon="send" disabled={disabled || isLoading || !isCOIPass} onClick={handleSubmit}>
                        {'ส่งพิจารณา'}
                      </SaveButton>
                    }
                  />
                </>
              ) : (
                <>
                  {schemaButton?.checkButton && (
                    <ApproverList
                      approveType={1}
                      projectversionId={projectId}
                      style={{ marginRight: 10, marginBottom: 10 }}
                      buttontext={schemaButton?.checkButton}
                      isLoading={isLoading}
                      fetchButton={(disabled) =>
                        schemaButton?.fetchButton && (
                          <FetchNewApprover
                            approveType={1}
                            projectversionId={projectId}
                            buttontext={schemaButton?.fetchButton}
                            onSuccess={onSuccess}
                            style={style}
                            disabled={disabled}
                          />
                        )
                      }
                    />
                  )}
                  {schemaButton?.cancelButton && isEmpty(selectedExpert) && (
                    <CancelApprovalList
                      approveType={1}
                      projectversionId={projectId}
                      style={{ marginRight: 10, marginBottom: 10 }}
                      buttontext={schemaButton?.cancelButton}
                      onSuccess={onSuccess}
                    />
                  )}
                </>
              )}

              {/* <Button
                style={{ width: 130 }}
                // appearance="ghost"
                color="rgb(45, 168, 136)"
                appearance="primary"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {'ส่งพิจารณา'}
              </Button> */}
            </Col>
          </Row>
        </Grid>
        <ConfirmWidget
          title={`ยืนยันการส่งพิจารณา`}
          show={isShowConfirm}
          detail={`กรุณายืนยันการส่งพิจารณา`}
          onCancle={onCancle}
          onConfirm={onConfirm}
        />
      </Panel>
    </>
  )
}
